// Shared helpers for Item component
import { FILTERS } from "../../constants/default";

export const acrissToCategory = (code) => {
  let found = false;
  if (code) {
    found = FILTERS.carGroup.items.find(item => {
      return (item.value.match(code[0]));
    });
  }
  return found ? found.title : "";
};

export const acrissToCarType = (code) => {
  let found = false;
  if (code) {
    found = FILTERS.carType.items.find(item => {
      return (item.value.match(code[1]));
    });
  }
  return found ? found.title : "";
};
